export enum ModalSteps {
  mobileInitial = 'mobileInitial',
  holidayTypes = 'holidayTypes',
  destinations = 'destinations',
  hotelBrands = 'hotelBrands',
  travellers = 'travellers',
}

export const MAX_SELECTIONS = 5

export const TRAVEL_PREFERENCES_HOTEL_BRANDS = [
  {
    name: 'Ayana',
    image: 'user-preferences-ayana',
  },
  {
    name: 'COMO',
    image: 'user-preferences-como',
  },
  {
    name: 'Hyatt',
    image: 'user-preferences-hyatt',
  },
  {
    name: 'Kempinski',
    image: 'user-preferences-kempinski',
  },
  {
    name: 'Le Meridien',
    image: 'user-preferences-le-meridien',
  },
  {
    name: 'Marriott',
    image: 'user-preferences-marriott',
  },
  {
    name: 'Melia',
    image: 'user-preferences-melia',
  },
  {
    name: 'Mercure',
    image: 'user-preferences-mercure',
  },
  {
    name: 'Mulia',
    image: 'user-preferences-mulia',
  },
  {
    name: 'Novotel',
    image: 'user-preferences-novotel',
  },
  {
    name: 'Outrigger',
    image: 'user-preferences-outrigger',
  },
  {
    name: 'Pullman',
    image: 'user-preferences-pullman',
  },
  {
    name: 'Shangri-La',
    image: 'user-preferences-shangri-la',
  },
  {
    name: 'Sheraton',
    image: 'user-preferences-sheraton',
  },
  {
    name: 'Sofitel',
    image: 'user-preferences-sofitel',
  },
  {
    name: 'The Star',
    image: 'user-preferences-the-star',
  },
  {
    name: 'W',
    image: 'user-preferences-w-hotels',
  },
  {
    name: 'Warwick',
    image: 'user-preferences-warwick',
  },
]

export const TRAVEL_PREFERENCES_STAYS = [
  {
    name: 'Adults-only',
    image: 'user-preferences-adults',
  },
  {
    name: 'All-inclusive',
    image: 'user-preferences-all-inclusive',
  },
  {
    name: 'Arts & Culture',
    image: 'user-preferences-arts-and-culture',
  },
  {
    name: 'Boutique',
    image: 'user-preferences-boutique',
  },
  {
    name: 'City Break',
    image: 'user-preferences-city',
  },
  {
    name: 'Family Friendly',
    image: 'user-preferences-family',
  },
  {
    name: 'Food & Wine',
    image: 'user-preferences-food',
  },
  {
    name: 'Homes & Villas',
    image: 'user-preferences-villas',
  },
  {
    name: 'Honeymoon',
    image: 'user-preferences-honeymoon',
  },
  {
    name: 'Outdoor Adventure',
    image: 'user-preferences-outdoor',
  },
  {
    name: 'Sun & Beach',
    image: 'user-preferences-beach',
  },
  {
    name: 'Sustainable Travel',
    image: 'user-preferences-sustainable',
  },
  {
    name: 'Ultra Lux',
    image: 'user-preferences-ultra-lux',
  },
  {
    name: 'Unique Stays',
    image: 'user-preferences-unique-stays',
  },
  {
    name: 'Wellness & Relaxation',
    image: 'user-preferences-wellness',
  },
  {
    name: 'Romantic',
    image: 'user-preferences-romantic',
  },
  {
    name: 'Group',
    image: 'user-preferences-group',
  },
  {
    name: 'Cruises',
    image: 'user-preferences-ht-cruise',
  },
]

export const tourOperators = [
  {
    name: 'Luxury Escapes Tours',
    image: 'user-preferences-le-tours',
  },
  {
    name: 'AAT Kings',
    image: 'user-preferences-aatkings',
  },
  {
    name: 'Insight Vacations',
    image: 'user-preferences-insight-vacations',
  },
  {
    name: 'Luxury Gold',
    image: 'user-preferences-luxury-gold',
  },
  {
    name: 'Trafalgar',
    image: 'user-preferences-trafalgar',
  },
]

export const cruiseLines = [
  {
    name: 'Luxury Escapes Cruises',
    image: 'user-preferences-le-cruises',
  },
  {
    name: 'Azamara',
    image: 'user-preferences-azamara',
  },
  {
    name: 'Carnival Cruise Line',
    image: 'user-preferences-carnival',
  },
  {
    name: 'Celebrity Cruises',
    image: 'user-preferences-celebrity',
  },
  {
    name: 'Celestyal Cruises',
    image: 'user-preferences-celestyal',
  },
  {
    name: 'Coral Expeditions',
    image: 'user-preferences-coral',
  },
  {
    name: 'Crystal Cruises',
    image: 'user-preferences-crystal',
  },
  {
    name: 'Cunard',
    image: 'user-preferences-cunard',
  },
  {
    name: 'Disney Cruise Line',
    image: 'user-preferences-disney',
  },
  {
    name: 'Dream Cruises',
    image: 'user-preferences-dream',
  },
  {
    name: 'Holland America Line',
    image: 'user-preferences-holland',
  },
  {
    name: 'MSC Cruises',
    image: 'user-preferences-msc',
  },
  {
    name: 'Norwegian Cruise Line',
    image: 'user-preferences-norwegian',
  },
  {
    name: 'P&O Cruises',
    image: 'user-preferences-p&o',
  },
  {
    name: 'Princess Cruises',
    image: 'user-preferences-princess',
  },
  {
    name: 'Regent Seven Seas',
    image: 'user-preferences-regent',
  },
  {
    name: 'Royal Caribbean',
    image: 'user-preferences-royal',
  },
  {
    name: 'Seabourn',
    image: 'user-preferences-seabourn',
  },
  {
    name: 'Silversea',
    image: 'user-preferences-silversea',
  },
  {
    name: 'Uniworld',
    image: 'user-preferences-uniworld',
  },
  {
    name: 'Viking Cruises',
    image: 'user-preferences-viking',
  },
  {
    name: 'Virgin Voyages',
    image: 'user-preferences-virgin',
  },
]

export const TRAVEL_PREFERENCES_DESTINATIONS = [
  {
    destination: {
      name: 'Australia',
      countryCode: 'AU',
      placeId: 'le_d3d9446802a44259755d38e6d163e820',
    },
    image: 'user-preferences-australia',

  },
  {
    destination: {
      name: 'Bali',
      countryCode: 'ID',
      placeId: 'le_64930b7151b6bc3e289f37d5da62ac9f',
    },
    image: 'user-preferences-bali',
  },
  {
    destination: {
      name: 'Thailand',
      countryCode: 'le_8f85517967795eeef66c225f7883bdcb',
      placeId: 'TH',
    },
    image: 'user-preferences-thailand',
  },
  {
    destination: {
      name: 'Fiji',
      countryCode: 'FJ',
      placeId: 'le_72b32a1f754ba1c09b3695e0cb6cde7f',
    },
    image: 'user-preferences-fiji',
  },
  {
    destination: {
      name: 'Maldives',
      countryCode: 'MV',
      placeId: 'le_2723d092b63885e0d7c260cc007e8b9d',
    },
    image: 'user-preferences-maldives',
  },
  {
    destination: {
      name: 'Singapore',
      countryCode: 'SG',
      placeId: 'le_bd4c9ab730f5513206b999ec0d90d1fb',
    },
    image: 'user-preferences-singapore',
  },
  {
    destination: {
      name: 'New Zealand',
      countryCode: 'NZ',
      placeId: 'le_9fc3d7152ba9336a670e36d0ed79bc43',
    },
    image: 'user-preferences-new-zealand',
  },
  {
    destination: {
      name: 'Vietnam',
      countryCode: 'VN',
      placeId: 'le_a597e50502f5ff68e3e25b9114205d4a',
    },
    image: 'user-preferences-vietnam',
  },
  {
    destination: {
      name: 'Malta',
      countryCode: 'MT',
      placeId: 'le_698d51a19d8a121ce581499d7b701668',
    },
    image: 'user-preferences-malta',
  },
  {
    destination: {
      name: 'United States of America',
      countryCode: 'US',
      placeId: 'le_757b505cfd34c64c85ca5b5690ee5293',
    },
    image: 'user-preferences-usa',
  },
  {
    destination: {
      name: 'Canada',
      countryCode: 'CA',
      placeId: 'le_c16a5320fa475530d9583c34fd356ef5',
    },
    image: 'user-preferences-canada',
  },
  {
    destination: {
      name: 'Italy',
      countryCode: 'IT',
      placeId: 'le_93db85ed909c13838ff95ccfa94cebd9',
    },
    image: 'user-preferences-italy',
  },
  {
    destination: {
      name: 'Cook Islands',
      countryCode: 'CK',
      placeId: 'le_3416a75f4cea9109507cacd8e2f2aefc',
    },
    image: 'user-preferences-cook-islands',
  },
  {
    destination: {
      name: 'Malaysia',
      countryCode: 'MY',
      placeId: 'le_a3c65c2974270fd093ee8a9bf8ae7d0b',
    },
    image: 'user-preferences-malaysia',
  },
  {
    destination: {
      name: 'United Arab Emirates',
      countryCode: 'le_a2557a7b2e94197ff767970b67041697',
      placeId: 'AE',
    },
    image: 'user-preferences-united-arab-emirates',
  },
]
